import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "./LeadershipTab.module.css";

export default function LeadershipTab() {
  const [members, setMembers] = useState<any[]>([]);
  const roles = [
    "President",
    "Vice President",
    "Secretary Treasurer",
    "Lead Visitor Host",
  ];

  const load = () => {
    axios
      .get(
        (process.env.REACT_APP_API_URL || "http://localhost:8080") +
          "/api/members"
      )
      .then((r) => setMembers(r.data.data));
  };

  useEffect(() => load(), []);

  const updateRole = async (id: string, role: string) => {
    const token = localStorage.getItem("bni_token");

    try {
      await axios.put(
        (process.env.REACT_APP_API_URL || "http://localhost:8080") +
          "/api/members/" +
          id,
        { memberType: role },
        { headers: { Authorization: "Bearer " + token } }
      );
      load();
    } catch (error) {
      console.log("error while fetchinh members details", error);
    }
  };

  return (
    <div>
      <h2 className={styles.title}>Assign Leadership Roles</h2>

      {members.map((m) => (
        <div key={m._id} className={styles.card}>
          <div>
            <h3>{m.name}</h3>
            <p>{m.orgName}</p>
          </div>

          <select
            value={m.memberType || ""}
            onChange={(e) => updateRole(m._id, e.target.value)}
            className={styles.select}
          >
            <option value="">Select Role</option>
            {roles.map((r) => (
              <option key={r} value={r}>
                {r}
              </option>
            ))}
          </select>
        </div>
      ))}
    </div>
  );
}
